import React from "react";
//#region types
import { ACTION_SEPARATOR, MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { ProfileMoreActionsProps } from "models/propTypes/userProfilePropTypes";
import { IconDefinitionConstants, RouteConstants, SettingsConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { MenuButton, useCompanyLoadingState } from "components/common";
import { useNavigate } from "react-router";
//#endregion
import { AuthHelper, LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { useLocation } from "react-router-dom";

const ProfileMoreActions: React.FC<ProfileMoreActionsProps> = (props) => {
  const { userName, button, navCollapsed } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const onLogoutClick = () => {
    AuthHelper.logout();
    navigate("/Login");
  };

  const onSettingsClick = async (section: string) => {
    navigate(UrlHelper.formatPath(`/Settings?${RouteConstants.QueryParamStrings.Section}=${section}`), {
      state: { background: location },
    });
  };

  const isCompanyLoading = useCompanyLoadingState();

  const userProfileMoreItems: MoreActionMenuItemType[] = [
    userName,
    {
      menuKey: "companySettings",
      description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Settings),
      icon: IconDefinitionConstants.WSettings,
      highlightType: StyleEnums.DisplayType.None,
      onClickHandler: onSettingsClick.bind(null, SettingsConstants.NavigationKey.Company),
      hidden: isCompanyLoading,
    },
    {
      menuKey: "myProfileSettings",
      description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.MyProfile),
      icon: IconDefinitionConstants.WPerson,
      highlightType: StyleEnums.DisplayType.None,
      onClickHandler: onSettingsClick.bind(null, SettingsConstants.NavigationKey.MyProfile),
      hidden: isCompanyLoading,
    },
    ACTION_SEPARATOR,
    {
      menuKey: "logout",
      description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Logout),
      icon: IconDefinitionConstants.WLogout,
      highlightType: StyleEnums.DisplayType.None,
      onClickHandler: async () => {
        onLogoutClick();
      },
    },
  ];

  return (
    <MenuButton
      menuItems={userProfileMoreItems}
      button={button}
      menuPlacement={navCollapsed ? "bottom-start" : "bottom-end"}
      onActionSuccess={() => {}}
      classes={{
        menuOpen: cssExports.userProfileMoreActionsMenuOpen,
      }}
    />
  );
};

export default ProfileMoreActions;
